import { FeedbackIcon, SuccessCelebrationIcon } from "../../icons";
// import { TrendingCryptoSlider } from "../common/TrendingCryptoSlider";
// import { useNavigate } from "react-router-dom";
// import { formatCryptoAmount } from "../../utils/format";
import HelpModal from "../../../components/Modals/HelpModal";
import { useState } from "react";
import { formatCryptoValue, formatFiatValue } from "../../utils/format";


const OrderSuccessStep = ({
  activeTab = "Buy",
  selectedFiatAccount,
  selectedCryptoAccount,
  amount,
  rfq,
  onClose
}) => {
  // const cryptoAccounts = useSelector((state) => state.client.clientInfo.crypto_accounts);
  // const navigate = useNavigate();
  const [helpModalOpen, setHelpModalOpen] = useState(false);
  const isSell = activeTab === "Sell";
  const successMessage = isSell
    ? "Your fiat has been credited to your destination account"
    : "Your assets are now available";

  // const cryptoDisplay = `${formatCryptoAmount(rfq?.cryptoAmount)} ${selectedCryptoAccount?.currency_code}`;
  // const cryptoDisplay = `${rfq?.cryptoAmount} ${selectedCryptoAccount?.currency_code}`;
  // const fiatDisplay = `${rfq?.paymentAmount} ${selectedFiatAccount?.currency_code}`;
  const cryptoDisplay = `${formatCryptoValue(rfq?.cryptoAmount, selectedCryptoAccount?.decimals)} ${selectedCryptoAccount?.currency_code}`;
  const fiatDisplay = `${formatFiatValue(rfq?.paymentAmount)} ${selectedFiatAccount?.currency_code}`;

  return (
    <div className="flex h-full min-h-0 flex-col overflow-y-auto hide-scrollbar px-6 max-sm:pt-[20px] pt-4">
      <div className="flex flex-col items-center gap-2 pb-4">
        <div className="flex flex-col items-center w-full space-y-10">
          <SuccessCelebrationIcon className="-mt-10 -mb-10" />

          <div className="flex w-full flex-col items-center gap-20">
            <div className="flex flex-col items-center gap-2 text-center">
              <p className="text-base font-medium leading-7 text-text-primary">
                Successful
              </p>

              {isSell ?
                <div className="flex flex-col items-center gap-1.5 text-text-primary">
                  <p className={`w-full text-center text-3xl font-medium leading-[21px]`}>
                    {fiatDisplay}
                  </p>
                  
                  {/* <span className="whitespace-nowrap text-md font-normal leading-[16.5px] text-text-secondary">
                    ≈ {cryptoDisplay}
                  </span> */}
                </div>
                : 
                <div className="flex flex-col items-center gap-1.5 text-text-primary">
                  <p className={`w-full text-center text-3xl font-medium leading-[21px]`}>
                    {cryptoDisplay}
                  </p>
                  
                  {/* <span className="whitespace-nowrap text-md font-normal leading-[16.5px] text-text-secondary">
                    ≈ {fiatDisplay}
                  </span> */}
                </div>
              }
              <p className="text-xs font-medium leading-[21px] text-[#979797]">
                {successMessage}
              </p>
            </div>

            <button
              type="button"
              // onClick={() => navigate('/v2/crypto-transaction-history')}
              onClick={onClose}
              className="flex h-12 w-full items-center justify-center rounded-[10px] bg-[#4ab933] text-sm font-semibold leading-[21px] text-white custom-transition hover:bg-[#3fa82c]"
            >
              Check Accounts
            </button>
          </div>
        </div>

        <HelpModal
          HelpModalOpen={helpModalOpen}
          setHelpModalOpen={setHelpModalOpen}
          className={"w-full"}
        >
          <button
            type="button"
            className="flex h-12 w-full items-center justify-between rounded-[10px] border border-divider px-4 py-2.5 custom-transition hover:bg-option-hover"
          >
            <span className="text-sm font-medium leading-[19.5px] text-text-primary">
              Provide Feedback
            </span>
            <FeedbackIcon />
          </button>
        </HelpModal>
      </div>
    </div>
  );
};

export default OrderSuccessStep;
